import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-tags o-searchTags"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "m-tag__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_icon = _resolveComponent("a-icon")!

  return (!$data.isDesktop && $options.hasFilters)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (item, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: index,
            type: "button",
            class: "m-tag isChecked",
            onClick: ($event: any) => (
                $options.switchFilter({
                    key: item.key,
                    label: item.label,
                    shortName: item.shortName,
                    value: item.value,
                })
            )
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1 /* TEXT */),
            _createVNode(_component_a_icon, { name: "close" })
          ], 8 /* PROPS */, _hoisted_2))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}